<template>
  <div :class="[colSizes, 'mb-3']" key="new">
    <router-link
      tag="div"
      :to="route"
      id="NewItemCard"
      class="card card-colorful"
    >
      <div class="card-body">
        <v-icon
          name="plus"
          class="actions-icon"
          :title="$t('navigation.' + route.name)"
        />
        <p class="card-text"></p>
      </div>
    </router-link>
  </div>
</template>

<script>
import "vue-awesome/icons/plus";
import { COL_SIZES_CARD_FULL_WIDTH, ROUTE_NEW_FOOD } from "./../constants";

export default {
  name: "NewItemCard",
  props: {
    route: {
      type: Object,
      default() {
        return {
          name: ROUTE_NEW_FOOD
        };
      }
    },
    colSizes: {
      type: String,
      required: false,
      default() {
        return COL_SIZES_CARD_FULL_WIDTH;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../assets/scss/variables";

.card-colorful {
  background-color: transparent;
  border: 1px dashed $color-primary;
  .card-body {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    background-color: $color-primary;
    svg {
      color: #fff;
    }
  }
}
</style>
